import { SlotGameType1_21 } from '../SlotGameType1_21';

export class CloverGirlDiamondFillingPot21 extends SlotGameType1_21
{
}
